import { render } from "./ConfusionMatrixCardV2.vue?vue&type=template&id=e6520fe6"
import script from "./ConfusionMatrixCardV2.vue?vue&type=script&lang=js"
export * from "./ConfusionMatrixCardV2.vue?vue&type=script&lang=js"

import "./ConfusionMatrixCardV2.vue?vue&type=style&index=0&id=e6520fe6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__